import { GenIcon } from '../helpers/IconBase.es.js';

const DownloadOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 7C3.75 6.30964 4.30964 5.75 5 5.75H7.90909C8.3233 5.75 8.65909 5.41421 8.65909 5C8.65909 4.58579 8.3233 4.25 7.90909 4.25H5C3.48122 4.25 2.25 5.48122 2.25 7V17.4C2.25 18.9188 3.48122 20.15 5 20.15H19C20.5188 20.15 21.75 18.9188 21.75 17.4V7C21.75 5.48122 20.5188 4.25 19 4.25H16.0909C15.6767 4.25 15.3409 4.58579 15.3409 5C15.3409 5.41421 15.6767 5.75 16.0909 5.75H19C19.6904 5.75 20.25 6.30964 20.25 7V17.4C20.25 18.0904 19.6904 18.65 19 18.65H5C4.30964 18.65 3.75 18.0904 3.75 17.4V7ZM11.8783 4.25C12.2925 4.25 12.6283 4.58579 12.6283 5V12.4754L14.8181 10.2171C15.1064 9.91978 15.5813 9.91248 15.8786 10.2008C16.176 10.4892 16.1833 10.964 15.8949 11.2614L12.4167 14.8483C12.3727 14.8937 12.3235 14.9329 12.2706 14.9654C12.1921 15.0137 12.1041 15.0479 12.0101 15.0645C11.9669 15.0723 11.9228 15.0762 11.8783 15.0762C11.8329 15.0762 11.7879 15.0721 11.7438 15.0641C11.6547 15.0479 11.571 15.016 11.4958 14.9714C11.4391 14.9377 11.3865 14.8965 11.3398 14.8483L7.86157 11.2614C7.57322 10.964 7.58052 10.4892 7.87788 10.2008C8.17525 9.91248 8.65007 9.91978 8.93842 10.2171L11.1283 12.4754V5C11.1283 4.58579 11.4641 4.25 11.8783 4.25Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { DownloadOutlined };
